import { render, staticRenderFns } from "./CalendarAdminManager.vue?vue&type=template&id=5b7173c4&scoped=true&"
import script from "./CalendarAdminManager.vue?vue&type=script&lang=js&"
export * from "./CalendarAdminManager.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAdminManager.vue?vue&type=style&index=0&id=5b7173c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7173c4",
  null
  
)

export default component.exports